import React from 'react';

const Logo = ({ variant = 'full', className = '' }) => {
  const src = variant === 'icon' ? '/logo-icon.png' : '/logo.png';
  const alt = 'Magool Tech Solutions';

  return (
    <img
      src={src}
      alt={alt}
      className={`object-contain object-left ${className}`}
    />
  );
};

export default Logo;
